import axios from 'axios';
import { api, headers } from '../../app/conf';

export const pingEvents = (event_id, token) => axios({
    method: 'get',
    url: `${api}/events/${event_id}`,
    headers: {
        ...headers,
        "X-Access-Token": token,
    }
});

export const fetchFile = (file_name, token) => axios({
    url: `${api}/files/${file_name}`, //your url
    method: 'GET',
    responseType: 'blob', 
    headers: {
        ...headers,
        "X-Access-Token": token,
    }// important
}).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${file_name}`);
    link.click();               
});